import { useEffect, useRef, useState } from 'react';
import API from '../api';
import toastr from 'toastr';

export default function useGroupUpload(userId: number | undefined, enabled: boolean) {
  const [canUpload, setCanUpload] = useState(false);
  const [uploading, setUploading] = useState(false);
  const busy = useRef(false);
  useEffect(() => {
    let active = true;
    setCanUpload(false);
    if (enabled && userId) {
      API.get(`/users/groupUploadStatus/${userId}`)
        .then(response => { if (active) setCanUpload(response.data.canUpload === true); })
        .catch(() => { if (active) toastr.error('Unable to check Upload Group availability'); });
    }
    return () => { active = false; };
  }, [userId, enabled]);

  const uploadGroup = async () => {
    if (!enabled || !userId || !canUpload || busy.current) return;
    busy.current = true; setUploading(true);
    try {
      const response = await API.post(`/users/uploadGroup/${userId}`);
      if (response.data.completed) setCanUpload(false);
      toastr.success(response.data.message || 'Groups uploaded successfully');
    } catch (error: any) {
      if (error.response?.data?.completed) {
        setCanUpload(false);
        toastr.info(error.response.data.message);
      } else toastr.error(error.response?.data?.message || 'Group upload failed. Please try again.');
    } finally {
      busy.current = false; setUploading(false);
    }
  };
  return { canUpload, uploading, uploadGroup };
}
